import { useContext, useMemo } from 'react';

import { isCaliforniaState } from '@/utils/tax';
import { isCountryCodeUSA } from '@/utils/tax';
import { CheckoutContext } from '@/context/CheckoutContext';

const decodeFooterText = (encodedText?: string) => {
  const binaryText = atob(encodedText || '');
  const bytes = Uint8Array.from(binaryText, (char) => char.charCodeAt(0));
  return typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8').decode(bytes) : binaryText;
};

export const useApprovalText = () => {
  const { checkoutConfiguration, customer, addressDetails } = useContext(CheckoutContext);

  const footerConfiguration = checkoutConfiguration?.footerConfiguration;
  const customerGeoCountry = customer?.taxCountry ?? customer?.geoLocator?.countryCode2 ?? '';
  const isUSA = isCountryCodeUSA(customerGeoCountry);
  const customerGeoState = addressDetails?.state;

  const decodedRichtext = useMemo(() => {
    if (customerGeoState && isUSA) {
      const isCalifornia = isCaliforniaState(customerGeoState);
      const stateRichText =
        footerConfiguration?.fullFooterConfig?.[customerGeoCountry]?.[customerGeoState as string]?.richText;

      const finalText =
        stateRichText || (isCalifornia && footerConfiguration?.defaultCAText) || footerConfiguration?.defaultText || '';

      return decodeFooterText(finalText);
    }
    return decodeFooterText(footerConfiguration?.footerText || '');
  }, [footerConfiguration, customerGeoCountry, customerGeoState, isUSA]);

  return {
    footerText: decodedRichtext,
  };
};
